// 与杂货铺配置对应的每页请求量的标识
export const MARK = {
  SEARCHPIN: "searchPin",
};
